module.exports = __webpack_public_path__ + "b9867cda337dcb036106f88e340e3710.svg";